<!--
 * @Description: 
 * @Author: Ingyi
 * @Date: 2021-08-31 11:22:07
 * @LastEditors: Ingyi
 * @LastEditTime: 2021-08-31 11:22:07
-->
<template>
  <div class="brandTrade">
    <div class="brand-box">
       <div class="brand-search-box">
        <div class="brand-left">
          <a-icon @click="$router.push('/')" />首页 > <a-icon/>交易服务 > <a-icon  />商标交易<br />
        </div>
        <!-- <div style="padding: 20px; width: 80px">不限</div>
        <div class="brand-right">
          <div class="trade-tags" v-for="item in brands" :key="item.key">
            {{ item.value }}
          </div>
        </div> -->
      </div> 
<!-- 
      <div class="brand-search-box">
        <div class="brand-left"><a-icon type="inbox" />出售价格<br /></div>
        <div style="padding: 20px; width: 80px">不限</div>
        <div class="brand-right">
          <div class="trade-tags" v-for="item in prices" :key="item.value">
            {{ item.label }}
          </div>
        </div>
      </div> -->

      <!-- <div class="brand-search-box">
        <div class="brand-left"><a-icon type="inbox" />其他条件<br /></div>
        <div class="brand-right" style="justify-content: space-between; padding: 0 20px">
          <div>
            <a-select style="width: 120px" placeholder="注册类型">
              <a-select-option value="注册类型">注册类型</a-select-option>
            </a-select>
            <a-select style="width: 120px" placeholder="字符长度">
              <a-select-option value="字符长度">字符长度</a-select-option>
            </a-select>
            <a-select style="width: 120px" placeholder="注册年限">
              <a-select-option value="注册年限">注册年限</a-select-option>
            </a-select>
          </div>
          <a-input-search style="width: 220px" placeholder="搜索商标名" />
        </div>
      </div> -->

      <div class="brand-list">
        <div class="brand-item" v-for="item in productData" :key="item.id"  @click="()=>$router.push({path:'/brandDetail',query:{id:item.id}})">
          <img :src="item.photo" />   
          <div class="brand-item-content">
            <span>{{item.name}}</span>
            <p>{{item.areaCode}}</p>
            <span class="price">{{item.money==0?"面议":item.money}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from "../util/request";
export default {
  name: "brand-trade",
  data() {
    return {
      action: 1,
      productData:[],
      brandData: new Array(8).fill(""),
      brands: [],
      prices: [
        { label: "一万以下", value: "0:10000" },
        { label: "1-2万", value: "10000:20000" },
        { label: "2-5万", value: "20000:50000" },
        { label: "2-5万", value: "50000:999999999" },
      ],
    };
  },
  mounted() {
      let id=this.$route.query.id;
     this.paraId = id;
     console.log(id);
    this.queryProduct(id);
    this.queryBrand();
  },
  methods: {
      //交易服务
    queryProduct(param){
     
      request({
        url:"/api/client/common/product/list",
        params:{code:param,page:1,pageSize:999999999999}
      }).then((res)=>{
        if(res.code == "200"){
            this.productData = res.data.records;
        }else{
          this.$message.warning(res.msg)
        }
      })
    },
    queryBrand() {
      request({
        url: "/api/client/common/select/dict/list",
        params: {
          key: "trademarkclassify",
        },
      }).then((res) => {
        this.brands = res.data;
      });
    },
  },
};
</script>

<style lang="less">
.brandTrade {
  .brand-box {
    width: 1280px;
    margin: 0 auto;
    background: #fff;
    .brand-search-box {
      display: flex;
      border: 1px solid #ccc;
    }
    .brand-left {
      width: 320px;
      padding: 20px 0 20px 20px;
      font-size: 16px;
      font-weight: bold;
      span {
        font-size: 12px;
        font-weight: 100;
        color: #999;
      }
    }
    .brand-right {
      display: flex;
      flex: 1;
      justify-content: start;
      align-items: center;
      flex-wrap: wrap;
      .trade-tags {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 110px;
        height: 50px;
      }
    }
  }

  .brand-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: start;
    margin: 20px 0;
    .brand-item {
      width: 256px;
      height: 400px;
      background: #fff;
      border: 2px solid #f2f2f2;
      border-bottom: 5px solid #f2f2f2;
      padding: 20px;
      // margin-bottom: 15px;
      img {
        width: 100%;
        height: 240px;
        object-fit: contain;
      }
      .brand-item-content {
        margin-top: 15px;
        padding-bottom: 10px;
        display: flex;
        flex-direction: column;
        .price {
          color: #ce1b14;
          font-size: 28px;
          font-weight: bold;
        }
      }
    }
  }
}
</style>
